import type { ContractTerminationRequestPayload } from '@vy/api-definition';
import type { UseMutationOptions } from 'react-query';
import { useMutation, useQueryClient } from 'react-query';
import { getPrivateApi } from '../../services/api';
import {
  invalidateContractsQueries,
  invalidateCustomersQueries,
  invalidateBillingRevenueQueries,
} from '../../utils/query-invalidation';

export function useTerminateContractMutation(
  contractId: string,
  options?: UseMutationOptions<void, unknown, ContractTerminationRequestPayload>,
) {
  const queryClient = useQueryClient();

  return useMutation(
    ['terminate-contract'],
    async (terminateContractRequest) => {
      const api = getPrivateApi();

      await api.terminateContract({ contractId, terminateContractRequest });
    },
    {
      onSuccess: async () => {
        await Promise.all([
          queryClient.invalidateQueries({
            predicate: (query) => query.queryKey.includes(contractId),
          }),
          invalidateContractsQueries(queryClient),
          invalidateCustomersQueries(queryClient),
          invalidateBillingRevenueQueries(queryClient),
        ]);
      },
      ...options,
    },
  );
}
